import { createContext, useContext, useState, useEffect } from "react";
import React from 'react';
const VisitRequestContext = createContext();



export const VisitRequestProvider = ({ children }) => {


  const [visitRequestDetails, setVisitRequestDetails] = useState({}); 

  useEffect(() => {
    if (visitRequestDetails) {
      localStorage.setItem("visitRequestDetails", JSON.stringify(visitRequestDetails));
    }
  }, [visitRequestDetails]);

  return (
    <VisitRequestContext.Provider value={{visitRequestDetails }}>
      {children}
    </VisitRequestContext.Provider>
  );
};

export const useVisitRequest = () => useContext(VisitRequestContext);
